import el from 'vuetify/es5/locale/el';
import en from 'vuetify/es5/locale/en';
import fr from 'vuetify/es5/locale/fr';
import es from 'vuetify/es5/locale/es';
import it from 'vuetify/es5/locale/it';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import VueI18n from 'vue-i18n';
import i18n from '@/i18n';

Vue.use(VueI18n);
Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#581E5C',
        error: '#F27E7E',
      },
    },
  },
  lang: {
    locales: { el, en, fr, es, it },
    current: 'en',
    t: (key, ...params) => i18n.t(key, params),
  },
});
